<div class="download-success">
  <div class="download-success__header">
    <h3 class="download-success__title">Download Final Quote</h3>
    <button
      type="button"
      class="download-success__close"
      (click)="close()"
      aria-label="Close dialog"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <div class="download-success__body">
    <div class="download-success__icon" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
      >
        <mask
          id="mask0_dl_success"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="96"
          height="96"
        >
          <rect width="96" height="96" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_dl_success)">
          <path
            d="M42.4002 66.4001L70.6002 38.2001L65.0002 32.6001L42.4002 55.2001L31.0002 43.8001L25.4002 49.4001L42.4002 66.4001ZM48.0002 88.0001C42.4669 88.0001 37.2669 86.9501 32.4002 84.8501C27.5336 82.7501 23.3002 79.9001 19.7002 76.3001C16.1002 72.7001 13.2502 68.4668 11.1502 63.6001C9.05024 58.7335 8.00024 53.5335 8.00024 48.0001C8.00024 42.4668 9.05024 37.2668 11.1502 32.4001C13.2502 27.5335 16.1002 23.3001 19.7002 19.7001C23.3002 16.1001 27.5336 13.2501 32.4002 11.1501C37.2669 9.05012 42.4669 8.00012 48.0002 8.00012C53.5336 8.00012 58.7336 9.05012 63.6002 11.1501C68.4669 13.2501 72.7002 16.1001 76.3002 19.7001C79.9002 23.3001 82.7502 27.5335 84.8502 32.4001C86.9502 37.2668 88.0002 42.4668 88.0002 48.0001C88.0002 53.5335 86.9502 58.7335 84.8502 63.6001C82.7502 68.4668 79.9002 72.7001 76.3002 76.3001C72.7002 79.9001 68.4669 82.7501 63.6002 84.8501C58.7336 86.9501 53.5336 88.0001 48.0002 88.0001ZM48.0002 80.0001C56.9336 80.0001 64.5002 76.9001 70.7002 70.7001C76.9002 64.5001 80.0002 56.9334 80.0002 48.0001C80.0002 39.0668 76.9002 31.5001 70.7002 25.3001C64.5002 19.1001 56.9336 16.0001 48.0002 16.0001C39.0669 16.0001 31.5002 19.1001 25.3002 25.3001C19.1002 31.5001 16.0002 39.0668 16.0002 48.0001C16.0002 56.9334 19.1002 64.5001 25.3002 70.7001C31.5002 76.9001 39.0669 80.0001 48.0002 80.0001Z"
            fill="#78C01E"
          />
        </g>
      </svg>
    </div>
    <h3 class="download-success__heading">Success!</h3>
    <p class="download-success__text">Your download was completed successfully.</p>
  </div>
</div>
